import { getUniversalPosition } from './index';

/** @description Возвращает универсальные координаты для тач нажатия и клика
 * @param e {React.TouchEvent | React.MouseEvent} объект события мыши
 * @param lastCursorPosition {{ x: number, y: number }} прошлые координаты мыши
 * @return {{ x: number, y: number }}
 */
export var getCoordinates = function getCoordinates(e, lastCursorPosition) {
  var lastX = lastCursorPosition.x,
    lastY = lastCursorPosition.y;
  var _getUniversalPosition = getUniversalPosition(e),
    x = _getUniversalPosition.x,
    y = _getUniversalPosition.y;
  return {
    x: x,
    y: y,
    lastY: lastY,
    lastX: lastX,
    deltaX: lastX - x,
    deltaY: lastY - y
  };
};